module.exports = __webpack_public_path__ + "img/gigwicat1.c284aa10.jpg";